export default __webpack_public_path__ + "9edbed3107c2258168118ac88c3d519e.svg";